var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNuclear = function SvgNuclear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M11.1 17a5 5 0 0 0 1.585 2.743l-2.024 3.504A9 9 0 0 1 7.056 17zm8.216 2.743A5 5 0 0 0 20.9 17h4.045a9 9 0 0 1-3.607 6.247zM16 11c-.553 0-1.086.09-1.584.256l-2.023-3.504A9 9 0 0 1 16 7c1.284 0 2.504.268 3.607.752l-2.023 3.504A5 5 0 0 0 16 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
    clipRule: "evenodd"
  })));
};
export default SvgNuclear;